import React from 'react';
import styled from 'styled-components';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';
import { Icon, IconButton } from '@wegroup/design-system';

// Components
import OptionButton from '../../../../../../common/src/components/OptionButton';
import AnnexForm from './AnnexForm';
import AnnexDisplay from './AnnexDisplay';
import DashedButtonModal from '../accident/DashedButtonModal';

// Types
import { Annex } from '../../../../../../../types/SMT';
import { useTranslation } from 'react-i18next';

interface Props {
  annex: Annex;
  isEditing: boolean;
  setIsEditing: (arg0: boolean) => void;
  isMobile?: boolean;
  handleEdit: (arg0: Annex) => void;
  handleRemove: () => void;
}

const SingleAnnex: React.FC<React.PropsWithChildren<Props>> = ({
  annex,
  isMobile,
  isEditing,
  handleEdit,
  handleRemove,
  setIsEditing,
}) => {
  const { t } = useTranslation();

  const finishEdit = (annex: Annex) => {
    setIsEditing(false);
    handleEdit(annex);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleMobileClick = () => {
    if (isMobile) setIsEditing(true);
  };

  if (isMobile) {
    return (
      <>
        {isEditing && (
          <DashedButtonModal isOpen={isEditing}>
            <AnnexForm
              annex={annex}
              isMobile={isMobile}
              handleSave={finishEdit}
              handleRemove={handleRemove}
              handleCancel={handleCancel}
            />
          </DashedButtonModal>
        )}
        <Container data-test-id="ProdFac_SingleAnnex">
          <AnnexDisplay annex={annex} onClick={handleMobileClick} />
          {isMobile && (
            <IconButton
              position={{ base: 'relative', mobileL: 'absolute' }}
              top={{ base: '0', mobileL: '2' }}
              right={{ base: '0', mobileL: '2' }}
              ml="3"
              variant="white"
              icon={<Icon name="GeneralActionsEditDocument" />}
              aria-label="edit-button"
              onClick={handleMobileClick}
            />
          )}
        </Container>
      </>
    );
  }

  if (isEditing)
    return (
      <AnnexForm
        annex={annex}
        handleSave={finishEdit}
        handleRemove={handleRemove}
        handleCancel={handleCancel}
      />
    );

  return (
    <Container>
      <AnnexDisplay annex={annex} onClick={handleMobileClick} />
      <OptionButton
        editText={t('Edit annex')}
        removeText={t('Remove annex')}
        onEdit={() => setIsEditing(true)}
        onRemove={handleRemove}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 1.2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
    0 0 1px rgba(0, 0, 0, 0.04);
  background-color: white;

  ${mq.mobileL} {
    justify-content: center;
    width: 22rem;
    height: 22rem;
    border-radius: 6px;
  }
`;
export default SingleAnnex;
